import { editTitle } from "../actions";

const updateTitle = (todoId, text) => {
  return async (dispatch) => {
    const response = await fetch(`https://redux-todo-by-tahmid.herokuapp.com/todos/${todoId}`, {
      method: "PATCH",
      body: JSON.stringify({
        text: text,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const todo = await response.json();

    dispatch(editTitle(todo.id, todo.text));
  };
};

export default updateTitle;
